import { Injectable } from '@angular/core';
@Injectable()
export class PagerService {
    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {

        // Calcule o total de páginas
        const totalPages = Math.ceil(totalItems / pageSize);

        if (currentPage < 1) {
            currentPage = 1;
        } else if (currentPage > totalPages) {
            currentPage = totalPages;
        }

        let startPage: number;
        let endPage: number;
        if (totalPages <= 10) {
            // Menos ou igual a 10 páginas, então mostre tudo.
            startPage = 1;
            endPage = totalPages;
        } else {
            // Mais de 10 páginas, então calcule as páginas de início e final.
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // Calcular índices de itens iniciais e finais.
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // Cria uma variedade de páginas para NG-REPEAT no controle do pager.
        const pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

        // Retorna objeto com todas as propriedades do pager exigidas pela visualização.
        return {
            totalItems,
            currentPage,
            pageSize,
            totalPages,
            startPage,
            endPage,
            startIndex,
            endIndex,
            pages
        };
    }
}
